import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { postRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import messages from 'src/pages/TimeTrackingPage/messages';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import type { UserRecordType } from './useUpdateApproveTimeTracking';

type SaveTimeTrackingParamsType = {
  timeTrackingUuid: string;
  record: UserRecordType;
};

const updateSaveTimeTracking = async ({
  timeTrackingUuid,
  record,
}: SaveTimeTrackingParamsType) => {
  const params = {
    candidate_job_shift: {
      checkin_time: record.checkIn,
      checkout_time: record.checkOut,
      break_taken: record.isBreakTaken,
      comment: record.adminComment,
    },
  };

  const { data } = await postRequest<RequestSimplifiedData>(
    API.POST.saveTimeTracking(timeTrackingUuid),
    params,
  );

  return data;
};

export const useUpdateSaveTimeTracking = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: updateSaveTimeTracking,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.timeTrackingSaved), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.CANDIDATE_JOB_SHIFTS] });
    },
    onError: handleError,
  });
};
